import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        showDialog: false,
        drawer: null
    },
    mutations: {
        changeSaveAssessmentDialog(state, value) {
            state.showDialog = value
        },
        toggleDrawer(state) {
            state.drawer = !state.drawer
        }
    },
    actions: {
        changeSaveAssessmentDialog({ commit }, payload) {
            commit("changeSaveAssessmentDialog", payload)
        },
        toggleDrawer({ commit }, payload) {
            commit("toggleDrawer", payload)
        }
    }
})